export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  FORGOTTEN_PASSWORD: "/forgottenPassword",
  RESERVATIONS: "/reservations",
  RESERVATION: "/reservation",
  PAGE: "/page",
  NONE: "#",
  PROFILE: "/profile",
  REGISTER: "/register",
  BOOKED: "/booked",
  NOT_FOUND: "/404",
  BEST_OFFER_RESULTS: "/bestOfferResults",
  BEST_OFFERS: "/bestOffers",
  CREATE_NEW_PASSWORD: "/create-new-password",
  HOTEL: "/hotel",
  HOTELS: "/hotels",
  REDIRECT_TO_BOOKED: "/redirectToBooked",
  RESULT: "/result",
  RESULTS: "/results",
  IFRAME: "/iframe",
  BOOK_HOTEL: "/bookHotel",
  EMAIL_CONFIRM: "/emailconfirm",
  LOW_COST_SEARCH: "/lowCostSearch",
};

export const HOTEL_ROUTES = {
  HOTEL_BOOK: "/bookHotel",
  HOTEL_IFRAME: "/hotel/iframe",
  HOTEL_RESULTS: "/hotels",
  HOTEL_RESULT: "/hotel",
};
